{
  "title": "新手上路：主辦方第一次使用指南",
  "description": "從申請成為主辦方到日常營運競賽，快速了解主辦方在 NAPAICP 上完整的第一次使用流程。",
  "headings": ["你會完成什麼", "適用角色", "操作前確認", "操作步驟", "完成後", "常見問題"],
  "summary": "讀完後，您會知道如何申請成為主辦方、管理後台的六層分組架構、平時該看哪個頁面掌握競賽進度，以及一場競賽從建立到公布結果的完整生命週期。",
  "roleNote": "主辦方（competition_admin／staff）",
  "prerequisites": [
    "已登入且完成 Email 驗證",
    "若尚未擁有任何競賽的 competition_admin 或 staff 角色，需先送出主辦申請並經核准"
  ],
  "pathLabel": "/competition-requests（申請入口）或管理後台",
  "steps": [
    {
      "title": "1. 申請成為主辦方（若尚未擁有角色）",
      "description": "於右上角 Account Menu 點選「申請成為競賽主辦方」，前往 /competition-requests 填寫並送出申請；此申請本身不是正式競賽，也不會讓您取得任何 Competition Role。核准後伺服器會一次性自動建立正式競賽並將您設為第一位 competition_admin。"
    },
    {
      "title": "2. 認識管理後台的六層分組",
      "description": "進入任一競賽的管理後台後，左側導覽固定分為六層，順序為：設定（競賽基本資料與時程）、營運（隊伍與投稿的日常管理、公告與儀表板）、資料（參賽者、報名資料、資格驗證資料、匯出中心）、審查（評審邀請指派、Rubric、成績）、權限（Staff 與角色管理）、治理（Audit Log）。此順序反映競賽從設定到治理的邏輯順序，跨競賽的平台層級治理則屬於平台管理操作手冊的範圍。"
    },
    {
      "title": "3. 完成建立競賽的基本設定",
      "description": "在「設定」分組依序設定報名／投稿／評審時程、Eligibility 說明文字、Categories（組別）、Rounds（輪次）、公開頁面內容，以及視需要開啟的學生資格驗證政策。"
    },
    {
      "title": "4. 建立表單與評分規準",
      "description": "建立報名表單、團隊表單、投稿表單，以及評審用的評分規準（Rubric）；已發布的表單版本不可再修改，需要調整時建立新版本並重新發布。"
    },
    {
      "title": "5. 邀請評審並指派作品",
      "description": "在「評審邀請與指派」頁輸入評審 Email 送出邀請，若該 Email 尚無帳號，系統會自動建立帳號並寄送臨時密碼；報名／投稿截止後，於「作品指派」分頁批次將作品指派給評審。"
    },
    {
      "title": "6. 平時該看哪裡：營運儀表板",
      "description": "「營運」分組的「營運儀表板」是進入單一競賽後台後最先該看的頁面，一次呈現報名、參賽者、資格驗證、作品繳交、評審五組即時 KPI 與「待處理事項」清單；每個數字都可點擊，直接帶入對應清單頁的篩選條件。"
    },
    {
      "title": "7. 認識競賽的完整生命週期",
      "description": "設定 → 報名 → 投稿 → 評審 → 結果，是一場競賽從建立到公布結果依序經歷的高層流程。成績計算時，單一作品須至少有 2 位評審的有效鎖定分數才會被納入排名；結果一旦鎖定並公布即不可再變更，公布前務必完成所有覆核。"
    }
  ],
  "afterward": [
    "您可以隨時回到「營運儀表板」掌握目前競賽整體進度",
    "若申請被要求補件或拒絕，可在「我的申請」查看回饋並視情況修改重送",
    "所有涉及權限、成績、Deadline、結果公布的操作都會留下稽核紀錄，可在「治理」分組的 Audit Log 查詢"
  ],
  "nextSteps": "完整規則、每個分組的詳細操作與各項限制，請見「操作手冊：主辦方」；平時想快速掌握單一競賽的整體現況，請見「營運儀表板」相關說明。",
  "faq": [
    {
      "q": "我一定要先申請才能開始使用主辦方功能嗎？",
      "a": "是的。任何已登入且完成 Email 驗證的使用者都可以提出主辦申請，但需要經平台審核核准後，系統才會自動建立競賽並將您設為第一位 competition_admin；申請本身不會讓您取得任何角色。"
    },
    {
      "q": "六層分組的順序可以自訂嗎？",
      "a": "不行。設定／營運／資料／審查／權限／治理是固定順序的左側導覽分組，反映競賽營運從設定到治理的邏輯順序，目前沒有自訂排序的介面。"
    },
    {
      "q": "進入後台後應該先看哪一頁？",
      "a": "建議先看「營運」分組的「營運儀表板」，一次掌握報名、參賽者、資格驗證、作品繳交、評審五組即時 KPI 與待處理事項；細部設定（例如時程、組別）則在「設定」分組進行。"
    },
    {
      "q": "要通知參賽者最新消息，或寄 Email 給部分參賽者，要在哪裡做？",
      "a": "在「營運」分組的「公告」頁新增公告，並可勾選「同時寄 Email 通知」；收件人可依角色、類別、輪次、報名欄位篩選，寄出前會顯示人數與信件預覽，也可以先「寄測試信給我自己」。詳見「操作手冊：主辦方」的「公告管理與 Email 通知」。已寄出的 Email 無法收回。"
    }
  ]
}
